import React, {memo, useEffect, useState} from 'react';
import { withRouter } from 'react-router-dom';

import { currency } from '@helpers';
import useFeedbackStatistic from '@hooks/useFeedbackStatistic';

import { EMOJI_LIST } from 'components/Feedback/List/Item';
import Icon from 'components/Icon';
import Button from 'components/Button';
import { Spinner } from 'styles/common';

import useLayout from './useLayout';

import {
	FeedbackStatistic,
	Title,
	Chart,
	Line,
	ProgressBar,
	Indicator,
	Percent,
	Emoji,
	Count,
	List,
	Item,
	ChartWrapper,
	ArrowButton,
	ArrowHolder,
	Description,
	BackButton,
} from './style';
import {fetchCompanyConfig} from "@api/company";

const Statistic = ({ calculateHeight = () => {}, invoiceId, onBack }) => {
	const { list, sum } = useFeedbackStatistic(invoiceId);
	const {
		listRef,
		containerRef,
		onNext,
		onPrev,
		nextButtonRef,
		prevButtonRef,
	} = useLayout(list);
	const [settings, setSettings] = useState(null);
	useEffect(() => {
		fetchCompanyConfig().then(r => setSettings(r))
	}, []);
	useEffect(() => {
		setTimeout(() => {
			calculateHeight();
		}, 100);
	}, []);

	return (
		<FeedbackStatistic ref={containerRef}>
			{(!list || !settings ) ? (
				<Spinner $size='lg' $block $margin={70} />
			) : (
				<>
					<Title>
						نظر همکاران در مورد غذا <small>مجموع نظرات: {sum} نفر</small>
					</Title>

					{list.length > 1 && (
						<ArrowHolder>
							<ArrowButton $right onClick={onNext} ref={nextButtonRef}>
								<Icon name='angle-right' />
							</ArrowButton>

							<ArrowButton $left onClick={onPrev} ref={prevButtonRef}>
								<Icon name='angle-left' />
							</ArrowButton>
						</ArrowHolder>
					)}

					<List ref={listRef}>
						{list.map((item) => (
							<Item key={item.invoiceItemId}>
								<ChartWrapper>
									<Chart>
										{Object.keys(EMOJI_LIST).map((key) => {
											const emoji = EMOJI_LIST[key];

											const percent = Math.floor(
												(item.statistic[`sumFeedBackItemRate${emoji.value}`] /
													item.statistic.sumTotal) *
													100,
											);

											return (
												<Line key={emoji.value}>
													<ProgressBar>
														<Indicator $percent={percent} />
														<Percent>
															{`${percent > 0 ? `${percent}%` : ''}`}
														</Percent>
													</ProgressBar>
													<Emoji src={emoji.image} alt={emoji.title} />
													<Count>
														{
															item.statistic[
																`sumFeedBackItemRate${emoji.value}`
															]
														}{' '}
														نفر
													</Count>
												</Line>
											);
										})}
									</Chart>
									<h5 className='lg align-center'>{item.foodItemName}</h5>
									{settings?.showPrice && <h6 className='md align-center'>
										پرداختی شما: {currency(item.invoiceItemPrice)}
									</h6>}
								</ChartWrapper>
							</Item>
						))}
					</List>

					<Description>
						نظر تمامی همکاران شرکت شما درباره یک غذا در این بخش نمایش داده میشه
						و مبنای تصمیم گیری درباره اون غذاست.
					</Description>

					<BackButton>
						<Button outline color='grayMedium' onClick={onBack} size='sm'>
							بازگشت
						</Button>
					</BackButton>
				</>
			)}
		</FeedbackStatistic>
	);
};

const areEqual = (prev, next) =>
	prev.location.pathname === next.location.pathname &&
	prev.match === next.match;

export default withRouter(memo(Statistic, areEqual));
